import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import FirstStepOnboardingForm from "./FirstStepOnboardingForm";
import SecondStepOnboardingForm from "./SecondStepOnboardingForm";
import ThirdStepOnboardingForm from "./ThirdStepOnboardingForm";
import InfoBanner from "components/ProjectAndSearch/InfoBanner";
import AddCandidateCriteria from "components/HRFlow/steps/Step4Candidates/AddCandidateCriteria";

interface StepOnboardingModalProps {
    isVisible: boolean;
    onClose: () => void;
    setRefresh: React.Dispatch<React.SetStateAction<number>>;
}

const StepOnboardingModal: React.FC<StepOnboardingModalProps> = ({ isVisible, onClose, setRefresh }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [completedSteps, setCompletedSteps] = useState([true, false, false]);
    const [onboardingResponse, setOnboardingResponse] = useState<any>(null); // State for Step 1 response
    const [secondStepResponse, setSecondStepResponse] = useState<FormData | null>(null); // State for Step 1 response
    const [formData, setFormData] = useState<Record<string, any>>({});


    const handleNextStep = (stepData?: any) => {
        if (stepData) {
            if (currentStep === 0) {
                setOnboardingResponse(stepData); // Store response from Step 1
            } else if (currentStep === 1) {
                setSecondStepResponse(stepData); // Store response from Step 2
                setFormData(new FormData()); // Initialize new FormData object
                for (const key in stepData) {
                    if (Object.prototype.hasOwnProperty.call(stepData, key)) {
                        formData.append(key, stepData[key]); // Append second step data
                    }
                }
            }
        }
        const newSteps = [...completedSteps];
        newSteps[currentStep + 1] = true; // Enable the next step
        setCompletedSteps(newSteps);
        setCurrentStep(currentStep + 1);
    };

    const handleFinish = (finalData: any) => {
        setCurrentStep(0); // Reset to the first step
        setCompletedSteps([true, false, false]); // Reset the enable/disable steps
        setOnboardingResponse(null); // Clear any stored data in state
        onClose(); // Close the modal or wizard
        setRefresh(refresh => refresh + 1);
    };

    const steps = [
        {
            title: "Upload files for AI analyzer",
            content: <FirstStepOnboardingForm
                onNext={(data) => handleNextStep(data)}
            />,
        },
        {
            title: "Confirm and save",
            content: <SecondStepOnboardingForm
                onNext={(data) => handleNextStep(data)}
                initialData={onboardingResponse}
            />,
        },
        {
            title: "Finalize project information",
            content: <ThirdStepOnboardingForm formData={secondStepResponse} onClose={handleFinish}
            />,
        },
    ];

    const handleStepClick = (index: number) => {
        if (completedSteps[index]) {
            setCurrentStep(index);
        }
    };

    return (
        // <Modal
        //     title={
        //         <div style={{ display: "flex", alignItems: "center", marginBottom: "2%", padding: "1%" }}>
        //             <div style={{ display: "flex", alignItems: "center" }}>
        //                 <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
        //                     <g filter="url(#filter2_dii_12621_39177)">
        //                         <rect x="0" y="0" width="48" height="48" rx="8" fill="#F4EBFF" stroke="#E4E7EC" />
        //                         <path
        //                             d="M24 9.5L22.884 7.269C22.563 6.627 22.403 6.306 22.163 6.071C21.952 5.864 21.696 5.706 21.416 5.609C21.099 5.5 20.74 5.5 20.022 5.5H16.2C15.08 5.5 14.52 5.5 14.092 5.718C13.716 5.91 13.41 6.216 13.218 6.592C13 7.02 13 7.58 13 8.7V9.5M13 9.5H28.2C29.88 9.5 30.72 9.5 31.362 9.827C31.926 10.115 32.385 10.574 32.673 11.138C33 11.78 33 12.62 33 14.3V18.7C33 20.38 33 21.22 32.673 21.862C32.385 22.426 31.926 22.885 31.362 23.173C30.72 23.5 29.88 23.5 28.2 23.5H17.8C16.12 23.5 15.28 23.5 14.638 23.173C14.074 22.885 13.615 22.426 13.327 21.862C13 21.22 13 20.38 13 18.7V9.5Z"
        //                             fill="none"
        //                             stroke="#344054"
        //                             strokeWidth="2"
        //                             strokeLinecap="round"
        //                             strokeLinejoin="round"
        //                             transform="translate(0, 8)"
        //                         />
        //                     </g>

        //                     <defs>
        //                         <filter id="filter2_dii_12621_39177" x="-10" y="-10" width="68" height="68" filterUnits="userSpaceOnUse">
        //                             <feOffset dx="2" dy="2" result="offset" />
        //                             <feGaussianBlur stdDeviation="4" result="blur" />
        //                             <feBlend in="SourceGraphic" in2="blur" mode="normal" />
        //                         </filter>
        //                     </defs>
        //                 </svg>
        //             </div>
        //             <div style={{ marginLeft: "16px" }}>
        //                 <h2 style={{ fontSize: "20px", margin: 0 }}>
        //                     Create a Project <span style={{ color: "#845dda" }}> / Step {currentStep + 1}</span>
        //                 </h2>
        //                 <p style={{ color: "#888" }}>Create a project to be able to use AI assistant</p>
        //             </div>
        //         </div>
        //     }
        //     visible={isVisible}
        //     onCancel={onClose}
        //     footer={null}
        //     width={800}
        // >
        <>
            <InfoBanner
                title="Create a Project"
                description="Create a project by importing a job description, interview transcripts, research docs or other relevant files."
            />
            <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "2px solid #e8e8e8", marginBottom: "20px" }}>
                {steps.map((step, index) => (
                    <div
                        key={index}
                        onClick={() => handleStepClick(index)}
                        style={{
                            flex: 1,
                            textAlign: "center",
                            padding: "10px 20px",
                            cursor: completedSteps[index] ? "pointer" : "not-allowed",
                            pointerEvents: completedSteps[index] ? "auto" : "none",
                            fontWeight: currentStep === index ? "bold" : "normal",
                            color: currentStep === index ? "#845dda" : completedSteps[index] ? "#000" : "#ccc",
                            borderBottom: currentStep === index ? "2px solid #845dda" : "2px solid transparent",
                        }}
                    >
                        {step.title}
                    </div>
                ))}
            </div>
            <div>{steps[currentStep].content}</div>
        </>
        // </Modal>
    );
};

export default StepOnboardingModal;
